import React, { useState, useRef, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import { FileButton, Input } from "../../../../../../components/Form";

import { Form } from "@unform/web";
import { SubmitHandler, FormHandles } from "@unform/core";
import * as Yup from "yup";
import getValidationErrors from "../../../../../../helpers/getValidateErrors";
import api from "../../../../../../services/api";

import { SweetAlertContext } from "../../../../../../contexts/sweetAlert/alertContext";
import { ProdutoContext } from "../../../../../../contexts/produtos/produtosContext";
import { toast } from "react-toastify";

interface IUploadImagem {
  dados: any;
  setFiguraIcone: any;
  situacao?: any;
}

const UploadImagem: React.FC<IUploadImagem> = (props) => {
  // URL Params
  const { pId }: any = useParams();

  // Refs
  const formRef = useRef<FormHandles>(null);

  //Context
  const sweetAlert = useContext(SweetAlertContext);
  const produtoContext = useContext(ProdutoContext);

  // States
  const [imagem, setImagem] = useState(true);
  const [svg, setSvg] = useState<any>();

  // Effects
  useEffect(() => {
    if (
      props.dados &&
      props.dados.nomeImagem != "" &&
      props.dados.nomeImagem != undefined
    ) {
      formRef.current?.setFieldValue("nomeImagem", props.dados.nomeImagem);
      setImagem(false);
    }
  }, [props.dados]);

  const handleChangeField = () => {
    if (!produtoContext.entrouEmEdicao) {
      produtoContext.setEntrouEmEdicao(true);
    }
  };

  // Handles
  const handleSubmit: SubmitHandler<any> = async (form, { reset }) => {
    try {
      if (
        (props.situacao?.value === 1 || props.situacao?.value === 2) &&
        !produtoContext.entrouEmEdicao
      ) {
        sweetAlert.alert(
          "Atenção",
          "Você precisa salvar o cadastro para continuar com a atualização."
        );
        reset();
        return;
      }

      formRef.current?.setErrors({});

      const SUPPORTED_FORMATS = [
        "image/jpg",
        "image/jpeg",
        "image/png",
        "image/svg",
        "image/svg+xml",
      ];

      if (SUPPORTED_FORMATS.includes(form.imagem.type)) {
        Object.defineProperty(form.imagem, "dimensions", {
          value: await checkDimension(form.imagem),
        });
      }

      const schema = Yup.object().shape({
        imagem: Yup.mixed().test(
          "fileFormat",
          "O arquivo deve ser .jpg, .png ou .svg",
          (value) => value && SUPPORTED_FORMATS.includes(value.type)
        ),
      });
      await schema.validate(form, { abortEarly: false });

      const {
        data: { disponivel },
      } = await api.get(`perfil/disponivelMercado/${pId}`);

      if (disponivel) {
        produtoContext.setEntrouEmEdicao(true);
        sweetAlert.alert(
          "Atenção",
          "O material está disponível em mercado. Alteramos a situação para o modo edição. Salve o cadastro para continuar com a atualização."
        );
        reset();
        return;
      }

      // Se passou por tudo, segue o fluxo normal
      handleChangeField();

      if (form.imagem != null) {
        const arquivo = new FormData();
        arquivo.append("arquivo", form.imagem);
        arquivo.append("nomeArquivo", form.imagem.name);
        arquivo.append("idPerfil", pId);

        props.setFiguraIcone((state: any) => ({
          ...state,
          nomeImagem: form.imagem.name,
        }));

        await upload(arquivo);
      }

      formRef.current?.setFieldValue("nomeImagem", form.imagem.name);
      setImagem(false);
    } catch (err) {
      formRef.current?.setErrors(getValidationErrors(err));
      formRef.current?.clearField("nomeImagem");
      setImagem(true);
    }
  };

  const upload = async (arquivo: any) => {
    let promise = new Promise((resolve, reject) => {
      api
        .post("/perfil/uploadFigura", arquivo)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });

    await toast.promise(promise, {
      pending: "Enviando arquivo...",
      success: "Arquivo enviado com sucesso!",
      error: "Ocorreu um erro ao enviar o arquivo.",
    });
  };

  const handleUploadImagem = (e: any) => {
    if (e.target.files?.length != 0) {
      formRef.current?.submitForm();
    } else {
      setImagem(true);
      formRef.current?.clearField("nomeImagem");
      formRef.current?.setErrors({});
    }
  };

  // Função que checa o tamanho da imagem sem exibir em tela.
  function checkDimension(value: any) {
    return new Promise((resolve) => {
      if (value.type == "image/svg+xml") {
        const previewURL = URL.createObjectURL(value);
        setSvg(previewURL);
        const svgDom: any = document.getElementById("svgPreview");
        svgDom.onload = () => {
          const width = svgDom?.width;
          const height = svgDom?.height;
          const dimensions = [width, height];
          resolve(dimensions);
        };
      }

      const reader = new FileReader();
      reader.readAsDataURL(value);
      reader.onload = () => {
        const img = new (window as any).Image();
        img.src = reader.result;
        img.onload = () => {
          const width = img.width;
          const height = img.height;
          const dimensions = [width, height];
          resolve(dimensions);
        };
      };
    });
  }

  const handleAlterarNome = async (e: any) => {
    if (props.dados.nomeImagem != e.target.value && e.target.value) {
      const message = `Deseja realmente alterar o nome da Imagem?`;

      sweetAlert.warning(
        e.target.value,
        message,
        async () => {
          handleChangeField();

          await api
            .post("perfil/alterarNomeFigura", {
              idPerfil: pId,
              nomeArquivo: e.target.value,
            })
            .then((response) => {
              if (response.data.isValid) {
                toast.success(response.data.message);
              } else {
                toast.error(response.data.errors[0].errorMessage);
              }
            });
          props.dados.nomeImagem = e.target.value;
        },
        () => {
          formRef.current?.setFieldValue("nomeImagem", props.dados.nomeImagem);
        }
      );
    }
  };

  return (
    <>
      <img
        id="svgPreview"
        src={svg}
        style={{ maxWidth: "max-content", display: "none" }}
      />

      <div className="card">
        <div className="card-header h3">Imagem</div>
        <div className="card-body py-4">
          <Form ref={formRef} onSubmit={handleSubmit}>
            <div className="">
              <div className="d-flex align-items-center flex-column">
                <div className="mb-4">
                  <span
                    className="bg-blue text-white avatar mx-2"
                    style={{ fontSize: "0.7rem" }}
                  >
                    <strong>.jpg</strong>
                  </span>
                  <span
                    className="bg-azure text-white avatar mx-2"
                    style={{ fontSize: "0.7rem" }}
                  >
                    <strong>.png</strong>
                  </span>
                  <span
                    className="bg-cyan text-white avatar mx-2"
                    style={{ fontSize: "0.7rem" }}
                  >
                    <strong>.svg</strong>
                  </span>
                </div>
                <div className="w-100">
                  <label className="form-label">Nome do Arquivo</label>
                  <div className="input-group mb-2">
                    <Input
                      type="text"
                      name="nomeImagem"
                      className="form-control"
                      placeholder="Nenhum arquivo..."
                      onBlur={handleAlterarNome}
                    />
                    <FileButton name="imagem" onChange={handleUploadImagem} />
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default UploadImagem;
